import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { type AxiosResponse } from 'axios';
import { type GetPatientRecordsParams, type PatientRecord } from 'types/patient';

const PATIENTS_URL = `${BASE_URL}patients`;

type PatientServiceTypes = {
  getActiveRecord: (patientId: string) => Promise<AxiosResponse<PatientRecord>>;
  getRecords: (
    patientId: string,
    params?: GetPatientRecordsParams
  ) => Promise<AxiosResponse<PatientRecord[]>>;
};

export const PatientService: PatientServiceTypes = {
  getActiveRecord: async patientId => service.get(`${PATIENTS_URL}/${patientId}/records/active`),
  getRecords: async (patientId, params) =>
    service.get(`${PATIENTS_URL}/${patientId}/records`, { params }),
};
